(function () {
  async function addVariant(variantId) {
    const body = new URLSearchParams();
    body.set('id', String(variantId));
    body.set('quantity', '1');

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      body: body.toString(),
      credentials: 'same-origin'
    });

    const data = await res.json().catch(() => null);

    if (!res.ok) {
      const msg =
        data && (data.description || data.message)
          ? data.description || data.message
          : `HTTP ${res.status}`;
      throw new Error(msg);
    }

    return data;
  }

  async function removeByKey(itemKey) {
  if (!itemKey) {
    throw new Error('data-id nicht gefunden');
  }

  const body = new URLSearchParams();
  body.set('id', String(itemKey));
  body.set('quantity', '0');

  const res = await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    credentials: 'same-origin',
    body: body.toString()
  });

  const data = await res.json().catch(() => null);

  if (!res.ok) {
    const msg =
      data && (data.description || data.message)
        ? data.description || data.message
        : `HTTP ${res.status}`;
    throw new Error(msg);
  }

  return data;
}

  function resetTermsCheckbox() {
    const checkbox = document.querySelector('#CustomTermsCheckbox');
    const checkoutBtn = document.querySelector('#CartCheckoutButton');

    if (checkbox) checkbox.checked = false;
    if (checkoutBtn) checkoutBtn.disabled = true;
  }

  async function refreshAjaxCart() {
    const res = await fetch('/cart', {
      headers: { Accept: 'text/html' },
      credentials: 'same-origin'
    });

    const htmlText = await res.text();
    const doc = new DOMParser().parseFromString(htmlText, 'text/html');

    const curHolder = document.querySelector('#AjaxCartForm .cart-holder');
    const newHolder = doc.querySelector('#AjaxCartForm .cart-holder');
    if (curHolder && newHolder) {
      curHolder.innerHTML = newHolder.innerHTML;
    }

    const curTotals = document.querySelector('#AjaxCartSubtotal');
    const newTotals = doc.querySelector('#AjaxCartSubtotal');
    if (curTotals && newTotals) {
      curTotals.outerHTML = newTotals.outerHTML;
    }

    const curFS = document.querySelector('#FreeShippingBar');
    const newFS = doc.querySelector('#FreeShippingBar');
    if (curFS && newFS) {
      curFS.outerHTML = newFS.outerHTML;
    }

    const curCountText = document.querySelector('#AjaxCartForm .site-cart-heading .subtitle');
    const newCountText = doc.querySelector('#AjaxCartForm .site-cart-heading .subtitle');
    if (curCountText && newCountText) {
      curCountText.innerHTML = newCountText.innerHTML;
    }

    const curCount = document.querySelector('[data-cart-count]');
    const newCount = doc.querySelector('[data-cart-count]');
    if (curCount && newCount) {
      curCount.textContent = newCount.textContent;
    }

    setTimeout(resetTermsCheckbox, 50);
    setTimeout(resetTermsCheckbox, 200);
        
  }

  document.addEventListener('click', async function (e) {
    // Cross-sell Add: funktionierende Delegation beibehalten
    const addBtn = e.target.closest('[data-cross-sell-add]');
    if (addBtn) {
      e.preventDefault();

      const variantId = addBtn.getAttribute('data-variant-id');
      if (!variantId) return;

      addBtn.disabled = true;

      try {
        await addVariant(variantId);
        await refreshAjaxCart();
      } catch (err) {
        console.error('Cross-sell add failed:', err);
        alert(`Konnte nicht zum Warenkorb hinzufügen: ${err.message}`);
      } finally {
        addBtn.disabled = false;
      }

      return;
    }

    // Remove: nur diesen Teil per AJAX abfangen
const removeLink = e.target.closest('#AjaxCartForm a.remove');
if (removeLink) {
  e.preventDefault();
  e.stopPropagation();

  const cartItem = removeLink.closest('.cart-item');
  const itemKey = cartItem ? cartItem.getAttribute('data-id') : null;

  try {
    await removeByKey(itemKey);
    await refreshAjaxCart();
  } catch (err) {
    console.error('Cart remove failed:', err);
    alert(`Artikel konnte nicht entfernt werden: ${err.message}`);
  }

  return;
}
  }, true);

})();